import * as React from 'react'

import { cn } from '../lib/utils'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      // Border / focus / typography mirror `<Input>` exactly so a
      // form mixing inputs and textareas reads as one family. Uses the
      // `border-border` token — the single product-wide border — fully
      // transparent background (no dark tint), and matching
      // `px-3 py-2 text-base md:text-sm` padding/typography. Mobile holds
      // `text-base` (16px) so iOS Safari doesn't zoom the viewport on
      // focus (sub-16px inputs trigger a focus-zoom that never reverts).
      // `field-sizing-content` keeps the multi-line auto-grow behaviour.
      className={cn(
        'flex field-sizing-content min-h-16 w-full rounded-lg border border-border bg-transparent px-3 py-2 text-base transition-colors outline-none placeholder:text-foreground/50 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
